const getShiftPrevPeriodOverviewAPI = (shiftId) => `api/shift-admin/shift-prev-period-overview/${shiftId}`;

const getShiftCommissionsAPI = (shiftId) => `api/shift-admin/shift-commissions/${shiftId}`;

const getShiftAlertsFeedAPI = (id) => `api/shift-admin/alerts-feed?page=1&limit=10&branchId=${id}`;

const getShiftAlertsFeedPaginationAPI = ({ pageNumber, pageLimit, id }) =>
  `api/shift-admin/alerts-feed?page=${pageNumber}&limit=${pageLimit}&branchId=${id}`;

const saveAllInfractionsAPI = () => 'api/shift-admin/save-all-alerts-feed';

const saveUserInfractionAsRecordAPI = (feedId) => `api/shift-admin/alerts-feed/${feedId}`;

const deleteUserInfractionAPI = (feedId) => `api/shift-admin/alerts-feed/${feedId}`;

const getShiftChecklistFeedAPI = (page = 1, limit = 10, id) =>
  `api/shift-admin/checklist-feed?page=${page}&limit=${limit}&branchId=${id}`;

const markFailedChecklistAsCompletedAPI = (feedId) => `api/shift-admin/checklist-feed/${feedId}`;

const getShiftHotListFeedAPI = (branchId = 0) => `api/shift-admin/hot-list-feed?branchId=${branchId}`;

const getHotListVehicleByVinAPI = (vin) => `api/shift-admin/hot-list-vehicle?vin=${vin}`;

const addVehicleToManualHotListAPI = () => 'api/shift-admin/hot-list-feed';

const addHotListVehicleCommentAPI = (feedId) => `api/shift-admin/hot-list-feed/${feedId}/comments`;

const updateHotListVehicleCommentAPI = (feedId, commentId) =>
  `api/shift-admin/hot-list-feed/${feedId}/comments/${commentId}`;

const deleteHotListVehicleCommentAPI = (feedId, commentId) =>
  `api/shift-admin/hot-list-feed/${feedId}/comments/${commentId}`;

const archiveManualHotListAPI = (feedId) => `api/shift-admin/hot-list-feed/${feedId}`;

export const shiftAdminEndpoints = {
  getShiftPrevPeriodOverviewAPI,
  getShiftCommissionsAPI,
  getShiftAlertsFeedAPI,
  getShiftAlertsFeedPaginationAPI,
  saveAllInfractionsAPI,
  saveUserInfractionAsRecordAPI,
  deleteUserInfractionAPI,
  getShiftChecklistFeedAPI,
  markFailedChecklistAsCompletedAPI,
  getShiftHotListFeedAPI,
  getHotListVehicleByVinAPI,
  addVehicleToManualHotListAPI,
  addHotListVehicleCommentAPI,
  updateHotListVehicleCommentAPI,
  deleteHotListVehicleCommentAPI,
  archiveManualHotListAPI,
  getShiftInfractionsDataAPI: (shiftId, page, limit) => {
    if (shiftId) {
      return `api/shift/infractions/${shiftId}?page=${page}&limit=${limit}`;
    }
    return `api/shift/infractions?page=${page}&limit=${limit}`;
  },
  searchVinNumberAPI: (shiftTimeId = 0, vin) => `api/shift/${shiftTimeId}/spotted-vehicle?vin=${vin}`,
  getAutoSavePermissionsInfoAPI: () => 'api/settings/get-auto-save-permission-info',
  saveAutoSavePermissionsInfo: () => 'api/settings/save-auto-save-permissions',
  updateTimesheet: (shiftTimeId) => `api/stats/update-timesheet/${shiftTimeId}`,
  getTopRecoveryAgentDataAPI: (branchId, page = 1, limit = 10, dateStart, dateEnd, timezoneOffset) =>
    `api/reports/agents-list?branchId=${branchId}&page=${page}&limit=${limit}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`,
  getTopSpottersDataAPI: (branchId, page = 1, limit = 10, dateStart, dateEnd, timezoneOffset) =>
    `api/reports/spotters-list?branchId=${branchId}&page=${page}&limit=${limit}&dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`,
  getAverageWeeklyHoursAPI: (mtdStartDate, mtdEndDate, ytdStartDate, ytdEndDate, timezoneOffset, branchId) =>
    `api/reports/average-weekly-hours-list?mtdStartDate=${mtdStartDate}&mtdEndDate=${mtdEndDate}&ytdStartDate=${ytdStartDate}&ytdEndDate=${ytdEndDate}&timezoneOffset=${timezoneOffset}&branchId=${branchId}`,
  getAverageIdleHoursAPI: (mtdStartDate, mtdEndDate, ytdStartDate, ytdEndDate, timezoneOffset, branchId) =>
    `api/reports/average-idle-hours-list?mtdStartDate=${mtdStartDate}&mtdEndDate=${mtdEndDate}&ytdStartDate=${ytdStartDate}&ytdEndDate=${ytdEndDate}&timezoneOffset=${timezoneOffset}&branchId=${branchId}`,
  getAverageDriveTimeHoursAPI: (mtdStartDate, mtdEndDate, ytdStartDate, ytdEndDate, timezoneOffset, branchId) =>
    `api/reports/average-drive-time-hours-list?mtdStartDate=${mtdStartDate}&mtdEndDate=${mtdEndDate}&ytdStartDate=${ytdStartDate}&ytdEndDate=${ytdEndDate}&timezoneOffset=${timezoneOffset}&branchId=${branchId}`,
};
